const routes = [{
    path: '/',
    redirect: '/home'
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/index/index')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/home')
  },
  {
    path: '/achievement',
    name: 'achievement',
    meta: {
      title: '业绩'
    },
    component: () => import('@/views/achievement/achievement')
  },
  {
    path: '/achievementDetail',
    name: 'achievementDetail',
    meta: {
      title: '详情'
    },
    component: () => import('@/views/achievement/detail')
  },
  {
    path: '/member',
    name: 'member',
    meta: {
      title: '会员管理'
    },
    component: () => import('@/views/member/member')
  },
  {
    path: '/memberEdit',
    name: 'memberEdit',
    meta: {
      title: '修改资料'
    },
    component: () => import('@/views/member/memberEdit')
  },
  {
    path: '/memberBlessing',
    name: 'memberBlessing',
    meta: {
      title: '生日祝福'
    },
    component: () => import('@/views/member/memberBlessing')
  },
  {
    path: '/blessingTemplate',
    name: 'blessingTemplate',
    meta: {
      title: '祝福模板'
    },
    component: () => import('@/views/member/blessingTemplate')
  },
  {
    path: '/ranking',
    name: 'ranking',
    meta: {
      title: '比一比'
    },
    component: () => import('@/views/ranking/ranking')
  },
  {
    path: '/me',
    name: 'me',
    meta: {
      title: '我的'
    },
    component: () => import('@/views/me/me')
  },
  {
    path: '/remindSet',
    name: 'remindSet',
    meta: {
      title: '提醒设置'
    },
    component: () => import('@/views/me/remindSet')
  },
  {
    path: '/store-message',
    name: 'store-message',
    meta: {
      title: '选择门店'
    },
    component: () => import('@/views/store-message/store-message')
  }
]

export default routes
